import API from "../../../api.js";
import {
  HISTORY_LIST_REQUEST,
  HISTORY_LIST_SUCCESS,
  HISTORY_LIST_FAIL,
} from "../../constants/patientConstants/historyConstants.js";

export const listHistory = () => async (dispatch) => {
  try {
    dispatch({ type: HISTORY_LIST_REQUEST });
    const { data } = await API.get("/appointments/history");
    dispatch({ type: HISTORY_LIST_SUCCESS, payload: data });
  } catch (error) {
    dispatch({
      type: HISTORY_LIST_FAIL,
      payload: error.response?.data?.msg || error.message,
    });
  }
};
